import { FC, memo, ReactElement } from 'react';

import { type Icons, icons } from './icons';
import styles from './styles.module.css';

export type IconType = keyof Icons;

type Props = {
  name: IconType;
  className?: string;
};

export const Icon: FC<Props> = memo(({ className, name }): ReactElement => {
  const IconComponent = icons[name];

  return (
    <span className={[styles.icon, className].join(' ')}>
      <IconComponent />
    </span>
  );
});
